/*
 * @Description: 切换图标
 * @Author: yy
 * @LastEditors: yangyang yyangacom@163.com
 * @Date: 2019-05-08 14:11:40
 * @LastEditTime: 2023-06-29 17:19:51
 */

import React from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip'
import s from './index.css'
import Logo from '../Logo';
import { IconUrl } from '../../../../controller'

class EnterpriseLogo extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    iconId: PropTypes.string,
  }
  constructor(props) {
    super(props);
    this.state = {
      iconId: props.iconId || 1,
    }
  }

  onChange =(e) => {
    this.setState({
      iconId: e.target.value
    })
  }

  render() {
    const { className } = this.props
    const { iconId } = this.state;
    return (
      <div className={classNames(s.root, className)}>
        <Tooltip
          className={className}
          wrapperClassName={s.wrapperClassName}
          content={(
            <div className={s.wrapper}>
              <div className={s.label}>请输入企业id：</div> 
              <input value={iconId} className={s.inputText} onChange={this.onChange} />
            </div>
          )}>
          <div className={s.imgWrapper}>
            <img src={IconUrl(iconId)} />
          </div>
        </Tooltip>
        <span className={s.linkStr}>X</span>
        <Logo className={s.logo} />
      </div>
    )
  }
}

export default withStyles(s)(EnterpriseLogo)



// WEBPACK FOOTER //
// src/routes/visualChart/components/EnterpriseLogo/index.js